import { Config } from '../../Config';

// Design tokens copied from AquaUI's NormalTheme (@longline/aqua-ui), so that
// the Aqua map UI looks like AquaUI without pulling in the library and its
// ThemeProvider.
const AquaTheme = {
  font: {
    bodySmall: 'normal 400 12px/16px Roboto, sans-serif',
    bodyMedium: 'normal 400 14px/20px Roboto, sans-serif',
    dataSmall: 'normal 500 12px/20px "Roboto Mono", monospace',
    labelCaps: 'normal 700 10px/14px Roboto, sans-serif',
    labelSmall: 'normal 700 12px/16px Roboto, sans-serif',
    labelLarge: 'normal 500 16px/20px Roboto, sans-serif',
    headingSmall: 'normal 700 16px/24px Roboto, sans-serif',
  },
  radius: {
    normal: 12,
    strong: 16
  },
  colors: {
    primary: {
      1: "#35abe2",
      2: "#3c698a",
      3: "#2c4253",
      4: "#273c44",
      5: "#1c242a"
    },
    neutral: {
      95:  "#f3f3f3",
      100: "#ffffff",
      80:  "#cccccc",
      50:  "#808080",
      30:  "#4c4c4c",
      10:  "#191919"
    },
    accent: "#f6a44e",
  },
  // AquaUI's MainMenu background:
  gradient: "linear-gradient(#457298, #2C4253)",
  shadows: {
    small:  "0px 1px 2px 0px rgba(0,0,0,0.3), 0px 1px 3px 1px rgba(0,0,0,0.15)",
    medium: "0px 4px 8px 3px rgba(0,0,0,0.15), 0px 1px 3px 0px rgba(0,0,0,0.30)",
    large:  "0px 6px 10px 4px rgba(0,0,0,0.15), 0px 2px 3px 0px rgba(0,0,0,0.30)",
    inner:  "inset 0px 4px 8px 3px rgba(0,0,0,0.15), inset 0px 1px 3px 0px rgba(0,0,0,0.30)"
  },
  duration: 100
};

/** Does this site use the Aqua map UI? */
const isAqua = Config.UI.theme === 'aqua';

export { AquaTheme, isAqua }
